const getTaskByTypeFromProject = (project, type) => {
  return (
    project.tasks.find((task) => task.type === type)
  );
};

export default getTaskByTypeFromProject;
